// extracted by mini-css-extract-plugin
module.exports = {"logo":"_FourOhFour-logo-2dpy","container":"_FourOhFour-container-S5My","card":"_FourOhFour-card-3w76"};